/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ConversationalAgentInferencerTestOk
 */
export interface ConversationalAgentInferencerTestOk {
  /**
   *
   * @type {boolean}
   * @memberof ConversationalAgentInferencerTestOk
   */
  success: boolean;
}

/**
 * Check if a given object implements the ConversationalAgentInferencerTestOk interface.
 */
export function instanceOfConversationalAgentInferencerTestOk(
  value: object,
): value is ConversationalAgentInferencerTestOk {
  if (!('success' in value) || value['success'] === undefined) return false;
  return true;
}

export function ConversationalAgentInferencerTestOkFromJSON(json: any): ConversationalAgentInferencerTestOk {
  return ConversationalAgentInferencerTestOkFromJSONTyped(json, false);
}

export function ConversationalAgentInferencerTestOkFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerTestOk {
  if (json == null) {
    return json;
  }
  return {
    success: json['success'],
  };
}

export function ConversationalAgentInferencerTestOkToJSON(value?: ConversationalAgentInferencerTestOk | null): any {
  if (value == null) {
    return value;
  }
  return {
    success: value['success'],
  };
}
